<template>
  <div class="">
    <select @change="monthManager" class="custom-select text-center" v-model="selectedMonth">
      <option v-for="(month,index) in months" :value="index+1">{{ month }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "ReservationMonthManager",
  data() {
    return {
      selectedMonth: 0,
      months: [
        "فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"
      ],
    }
  },
  methods: {
    monthManager() {

      // add one index to it to be sync with month of the year
      const selectedMonth = this.selectedMonth ;
      this.$store.commit('Reservation/setMonth', selectedMonth)

      this.$emit('monthRange', true)
    }
  },
  mounted() {
    this.selectedMonth = this.$store.getters['Reservation/getMonth']
  }
}
</script>


<style scoped>

</style>